import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button/Button';
import { PhoneIcon } from '@/components/UI/Icons/Icons';
import { PhonesBottomSheet } from '@/components/PhonesBottomSheet/PhonesBottomSheet';
import { useOpenContacts } from '@/hooks/useOpenContacts';
import { useAdDetails } from '@/hooks/useAdDetails';
import { useFloatingButtonsVisibility } from '@/hooks/useFloatingButtonsVisibility';
import { useServerDataContext } from '@/contexts';

export const CallButton = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const { isCallsAvailable } = useFloatingButtonsVisibility();
  const { isContactsOpen, toggleContacts, getPhoneNumbers, phoneNumbers } =
    useOpenContacts();

  if (!adData?.id || !isCallsAvailable) return null;

  return (
    <>
      <Button
        data-testid="floating-call-button"
        appearance="green"
        isFullWidth
        onClick={() =>
          getPhoneNumbers({
            adId: adData.id,
            isFloatingButtonClicked: true,
          })
        }
        className="fixed-btn fixed-btn--phone js-bottom-phone"
      >
        <PhoneIcon /> {t('common.call')}
      </Button>
      <PhonesBottomSheet
        isOpen={isContactsOpen}
        close={toggleContacts}
        phones={phoneNumbers}
      />
    </>
  );
};
